<nav #navbar id="nav-menu" [class.bag-nav]="setBag" class="navbar navbar-default navbar-fixed-top navbar-scroll" [class.v2]="!router.isActive('/carte',false)"
    role="navigation">
    <div class="container">
        <div class="navbar-header page-scroll">
            <button type="button" class="navbar-toggle collapsed" (click)="isCollapsed = !isCollapsed"
                aria-expanded="false">
                <span class="sr-only">Toggle navigation</span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
            </button>
            <!-- <a class="navbar-brand" href="index.html">
                <img src="assets/images/logo1.png" height="50px" alt="logo">
            </a> -->
        </div>
        <div id="navbar" class="navbar-collapse collapse" [collapse]="isCollapsed">
            <ul class="nav navbar-nav navbar-right">
                <li class="logo">
                    <a class="page-scroll" [routerLink]="'/'" [class.login]="log">
                        <img src="assets/images/logo3.png" alt="logo">
                    </a>
                </li>
                <li [class.active]="router.isActive('/',true)">
                    <a class="page-scroll" [routerLink]="'/'">Accueil</a>
                </li>
                <li [class.active]="router.isActive('/carte',false)">
                    <a [routerLink]="'/carte'" class="cursor-pointer page-scroll">Commander</a>
                </li>
                <li [class.active]="router.isActive('/restaurant',false)">
                    <a class="page-scroll" [routerLink]="'/restaurant'">Restaurant</a>
                </li>

                <li [class.active]="router.isActive('/contact',false)">
                    <a class="page-scroll" [routerLink]="'/contact'">Contact</a>
                </li>
                <li *ngIf="!log">
                    <a routerLink="/compte/connexion" class="login">Connexion</a>
                </li>
                <li *ngIf="!log">
                    <a routerLink="/compte/inscription" class="login">Inscription</a>
                </li>
                <li *ngIf="log" [class.active]="router.isActive('/commandes',false)">
                    <a [routerLink]="'/commandes'">Commandes</a>
                </li>
                <li class="btn-group" dropdown *ngIf="log">
                    <button id="button-basic" dropdownToggle type="button" class="dropdown-toggle"
                        aria-controls="dropdown-basic">
                        Mon compte
                        <span class="caret"></span>
                    </button>
                    <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu"
                        aria-labelledby="button-basic">
                        <li>
                            <a [routerLink]="'/profil'">Profil</a>
                        </li>
                        <li>
                            <a [routerLink]="'/commandes'">Commandes</a>
                        </li>
                        <li role="separator" class="divider"></li>
                        <li>
                            <a (click)="logout()">Déconnexion</a>
                        </li>
                    </ul>
                </li>
                <!-- <li *ngIf="log">
                    <a role="button" class="login" (click)="logout()">Déconnexion</a>
                </li> -->
            </ul>
        </div>
    </div>
</nav>